// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import {
  GridActionsCellItem,
  GridColDef,
  GridPaginationModel,
  GridRowId,
} from "@mui/x-data-grid";
import { DeleteConfirmModal, Table } from "../../molecules";
import {
  useGetRoleMenuList,
  useDeleteRoleMenu,
  DeleteRoleMenuRequest,
  useAuthorization,
} from "../../../hooks";
import { Loading } from "../../atoms";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { downloadExcel } from "../../../util/downloadExcel";

export type RoleMenuListingTableProps = {
  onRowClick?: (data: { id: GridRowId; row: any }) => void;
  isMenuOpen?: boolean;
};

export const RoleMenuListingTable = ({
  onRowClick,
  isMenuOpen,
}: RoleMenuListingTableProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [queryOptions, setQueryOptions] = React.useState({});
  const { data, mutate: getRoleMenu, isLoading } = useGetRoleMenuList("ACTIVE");
  // const tableData = data?.data;
  const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(0);
  const {showDelete, showUpdate} = useAuthorization();
  const setSnackbar = useSetSnackBar();
  const { mutate: roleMenuDelete, isLoading: isDeleteLoading } =
    useDeleteRoleMenu();
    const [shouldRefresh, setShouldRefresh] = React.useState(false);



  useEffect(() => {
    if (!isMenuOpen) {
    const requestPayload = {
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      orderByDesc: true,
      ...getQueryParams(queryOptions),
    };
    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }
    getRoleMenu(
   requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setTableData(data?.data);
          } else {
            setTableData(data?.data);
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  }}, [
    getRoleMenu,
    paginationModel.page,
    paginationModel.pageSize,
    setSnackbar,
    queryOptions,
    shouldRefresh,
    isMenuOpen,
  ]);

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);
    getRoleMenu(
      {
        size: paginationModel.pageSize,
        page: paginationModel.page,
        orderBy: "CreateDate",
        orderByDesc: true,
      },
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setTableData(data?.data);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const deleteRow = React.useCallback(
    (menu: any) => () => {
      setIsDeleteModalOpen(true);
      setSelectedRowId(Number(menu.id));
    },
    []
  );

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteConfirm = () => {
    const deleteRequest: DeleteRoleMenuRequest = { id: selectedRowId };

    roleMenuDelete(deleteRequest, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          setShouldRefresh(prevState => !prevState);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseDeleteModal();
  };

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "actions",
        type: "actions",
        width: 80,
        getActions: (params) => [
          !!showDelete ?<GridActionsCellItem
            label="Sil"
            onClick={deleteRow(params.row)}
            showInMenu
          /> : <></>,
        ],
      },
      { field: "roleName", headerName: "Rol Adı", width:200 },
      { field: "menuName", headerName: "Menü Adı", width:200 },
      { field: "create", headerName: "Oluştur", width: 100, type: 'boolean' },
      { field: "read", headerName: "Oku", width: 100, type: 'boolean' },
      { field: "update", headerName: "Güncelle", width: 100, type: 'boolean' },
      { field: "delete", headerName: "Sil", width: 100, type: 'boolean' },
    ];
  }, [deleteRow, showDelete]);

  const onSave = () => {
    const requestPayload = {
      size: -1,
      page: 0,
      orderBy: "CreateDate",
      orderByDesc: true,
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    getRoleMenu(
      requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            function fieldValue(data) {
              return data.map((item) => {
                return {
                  "Rol Adı": item?.roleName,
                  "Menü Adı": item?.menuName,
              
          
                };
              });
            }
            const refactoredData = fieldValue(data?.data?.result );
            downloadExcel(refactoredData || [], "Rol Menü Listesi");
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };

  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      return setQueryOptions({});
    }
  
    const queryParams = getQueryParams(filters);
  
    const allValuesAtLeastThreeChars = Object.values(queryParams).every((value) => value?.toString().length >= 3);
    const atLeastOneValueThreeChars = Object.values(queryParams).some((value) => value?.toString().length >= 3);
    
    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;
  
    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }
  
    if ((allValuesAtLeastThreeChars || (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength))) {
      setQueryOptions(queryParams);
    }
  
    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;
  
  }, 500);
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  // Komponent içerisinde
  const previousQueryParams = React.useRef({});

  const hasLoading = isLoading || isDeleteLoading;
  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} p={2}>
    
          <>
            <Table
             columnVisibilityConfigKey="roleMenuListingListingColumnVisibilityKey"
              handleFilterChange={handleFilterChange}
              hasActiveFilters={hasActiveFilters}
              paginationModel={paginationModel}
              onPaginationModelChange={handleChangePagination}
              paginationMode="server"
              rowCount={tableData?.totalItems || 0}
              sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
              isRowSelectable={() => false}
              // disableColumnMenu
              onRowClick={!!showUpdate ? onRowClick : () => null}
              rows={tableData?.result || []}
              columns={columns}
              exportFileName="Rol Menü Listesi"
              onSave={() => onSave()}
            />
            <DeleteConfirmModal
              isOpen={isDeleteModalOpen}
              onClose={handleCloseDeleteModal}
              onConfirm={() => handleDeleteConfirm()}
            ></DeleteConfirmModal>
          </>
  
      </Stack>
    </>
  );
};
